module.exports = __webpack_public_path__ + "img/green_132.eae2ab05.png";